import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

export class SliderManager {
  constructor() {
    this.swiperInstances = []
    this.tabSwiperInstances = []
  }

  initSliders() {
    const sliders = document.querySelectorAll("[data-theme-point-slider]")

    sliders.forEach(slider => {
      // Пропускаем слайдеры внутри табов - они будут инициализированы отдельно
      if (slider.closest('.theme-point-panels')) {
        return
      }

      const parent = slider.closest('.theme-point__slider-block') || slider.parentElement
      const pagination = slider.querySelector('[data-theme-point-slider-pagination]')

      let swiperConfig = {
        modules: [Pagination],
        breakpoints: {
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            pagination: pagination ? {
              el: pagination,
              clickable: true,
            } : false
          }
        }
      }

      // Проверяем класс desktop-grow у родительского элемента
      if (parent && parent.classList.contains('desktop-grow')) {
        swiperConfig.breakpoints[992] = {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
          pagination: pagination ? {
            el: pagination,
            clickable: true,
          } : false
        }
      }

      const swiperInstance = new Swiper(slider, swiperConfig)
      this.swiperInstances.push(swiperInstance)
    })
  }

  initTabSliders(activePanel) {
    // Уничтожаем предыдущие экземпляры слайдеров в табах
    this.tabSwiperInstances.forEach(instance => {
      if (instance) {
        instance.destroy(true, true)
      }
    })
    this.tabSwiperInstances = []

    // Инициализируем слайдеры только в активной панели
    const slidersInPanel = activePanel.querySelectorAll("[data-theme-point-slider]")
    slidersInPanel.forEach(slider => {
      const pagination = slider.querySelector('[data-theme-point-slider-pagination]')

      let swiperConfig = {
        modules: [Pagination],
        breakpoints: {
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            pagination: pagination ? {
              el: pagination,
              clickable: true,
            } : false
          }
        }
      }

      const swiperInstance = new Swiper(slider, swiperConfig)
      this.tabSwiperInstances.push(swiperInstance)
    })
  }

  initTabs() {
    const tabBtns = document.querySelectorAll("[data-tab-button]")
    const tabPanels = document.querySelectorAll("[data-tab-panel]")

    if (tabBtns.length && tabPanels.length) {
      // Инициализируем слайдеры в активной панели при загрузке
      const activePanel = document.querySelector("[data-tab-panel][data-tab-panel-state='active']")
      if (activePanel) {
        setTimeout(() => {
          this.initTabSliders(activePanel)
        }, 100)
      }

      tabBtns.forEach(btn => {
        btn.addEventListener("click", () => {
          this.clearTabs()

          btn.setAttribute("data-tab-button-state", "active")

          let activeTabName = btn.getAttribute("data-tab-button")

          tabPanels.forEach(panel => {
            let panelName = panel.getAttribute("data-tab-panel")
            if (panelName === activeTabName) {
              panel.setAttribute("data-tab-panel-state", "active")

              // Переинициализируем слайдеры в активной панели
              setTimeout(() => {
                this.initTabSliders(panel)
              }, 100)
            }
          })
        })
      })
    }
  }

  clearTabs() {
    const tabBtns = document.querySelectorAll("[data-tab-button]")
    const tabPanels = document.querySelectorAll("[data-tab-panel]")

    tabBtns.forEach(btn => {
      btn.removeAttribute("data-tab-button-state")
    })

    tabPanels.forEach(panel => {
      panel.removeAttribute("data-tab-panel-state")
    })
  }

  destroy() {
    this.swiperInstances.forEach(instance => {
      if (instance) {
        instance.destroy(true, true)
      }
    })
    this.tabSwiperInstances.forEach(instance => {
      if (instance) {
        instance.destroy(true, true)
      }
    })
    this.swiperInstances = []
    this.tabSwiperInstances = []
  }

  init() {
    setTimeout(() => {
      this.initSliders()
      this.initTabs()
    }, 100)
  }
} 